function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useCallback } from 'react';
import { useRefCallback } from '@bydesign-ui/hooks';
import { classnames } from '@bydesign-ui/utils';
import { useDirection, usePrefixCls } from '@byte-design/config';
import { Checkbox } from '../checkbox';
import { Radio } from '../radio';
import { Check as Check1 } from '../../common/icons';
import { TreeMapState } from '../../models/tree-map';
export var ListItem = function ListItem(props) {
  var prefixCls = props.prefixCls,
      className = props.className,
      checked = props.checked,
      children = props.children,
      _props$checkable = props.checkable,
      checkable = _props$checkable === void 0 ? false : _props$checkable,
      indeterminate = props.indeterminate,
      _props$enableWrap = props.enableWrap,
      enableWrap = _props$enableWrap === void 0 ? false : _props$enableWrap,
      _props$radio = props.radio,
      radio = _props$radio === void 0 ? false : _props$radio,
      _props$chosen = props.chosen,
      chosen = _props$chosen === void 0 ? false : _props$chosen,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$readonly = props.readonly,
      readonly = _props$readonly === void 0 ? false : _props$readonly,
      _props$state = props.state,
      state = _props$state === void 0 ? TreeMapState.UNSELECTED : _props$state,
      onCheckboxChange = props.onCheckboxChange,
      style = props.style,
      _props$size = props.size,
      size = _props$size === void 0 ? 'md' : _props$size,
      _props$level = props.level,
      level = _props$level === void 0 ? 1 : _props$level,
      onClick = props.onClick,
      domRef = props.domRef,
      onMouseDown = props.onMouseDown,
      extra = _objectWithoutProperties(props, ["prefixCls", "className", "checked", "children", "checkable", "indeterminate", "enableWrap", "radio", "chosen", "disabled", "readonly", "state", "onCheckboxChange", "style", "size", "level", "onClick", "domRef", "onMouseDown"]);

  var direction = useDirection();
  var innerWrapperCls = classnames(usePrefixCls('list-item-inner-wrapper', {
    wrap: enableWrap
  }), usePrefixCls("".concat(prefixCls, "-inner-wrapper"), {
    rtl: direction === 'rtl'
  }));
  var cls = classnames(usePrefixCls('list-item-container', {
    disabled: disabled,
    readonly: readonly,
    size: size,
    level: "".concat(level),
    checked: state === TreeMapState.SELECTED,
    rtl: direction === 'rtl'
  }), usePrefixCls("".concat(prefixCls, "-container")), className);
  var radioCls = classnames(usePrefixCls('list-item-radio'), usePrefixCls("".concat(prefixCls, "-radio")));
  var checkboxCls = classnames(usePrefixCls('list-item-checkbox'), usePrefixCls("".concat(prefixCls, "-checkbox")));
  var chosenCls = classnames(usePrefixCls('list-item-chosen-icon'), usePrefixCls("".concat(prefixCls, "-chosen-icon")));
  var onCheckboxChangeCallback = useRefCallback(onCheckboxChange);
  var onClickCallback = useRefCallback(onClick);
  var handleClick = useCallback(function (e) {
    if (disabled || readonly) {
      return;
    }

    onClickCallback(e);
  }, [disabled, readonly]);
  return React.createElement("div", {
    className: cls,
    ref: domRef,
    style: style,
    onClick: handleClick,
    onMouseDown: onMouseDown
  }, checkable && (radio && React.createElement(Radio, {
    className: radioCls,
    onValueChange: onCheckboxChangeCallback,
    disabled: disabled || readonly,
    onClick: function onClick(e) {
      return e.stopPropagation();
    },
    onMouseDown: function onMouseDown(e) {
      return e.stopPropagation();
    },
    checked: state === TreeMapState.SELECTED
  }) || React.createElement(Checkbox, {
    className: checkboxCls,
    onValueChange: onCheckboxChangeCallback,
    disabled: disabled || readonly,
    onClick: function onClick(e) {
      return e.stopPropagation();
    },
    onMouseDown: function onMouseDown(e) {
      return e.stopPropagation();
    },
    checked: checked === undefined ? state === TreeMapState.SELECTED : checked,
    indeterminate: indeterminate === undefined ? state === TreeMapState.PARTIAL : indeterminate
  })), React.createElement("div", Object.assign({}, extra, {
    className: innerWrapperCls
  }), typeof children === 'function' ? children() : children), chosen && React.createElement(Check1, {
    className: chosenCls
  }));
};